import React, { FC, memo } from "react";

import { SocAuthCallbackScreen } from "../";

export const AccountFacebookRedirect: FC = memo(() => <SocAuthCallbackScreen network="facebook" />);
